import React from "react";
import { Bubble } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BubbleController,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  BubbleController,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

const BubbleChart = () => {
  const data = {
    datasets: [
      {
        label: "A",
        data: [{ x: 20, y: 2, r: 15 }],
        backgroundColor: "#E7A9C0",
      },
      {
        label: "B",
        data: [{ x: 40, y: 3, r: 25 }],
        backgroundColor: "#923351",
      },
      {
        label: "C",
        data: [{ x: 70, y: 7, r: 35 }],
        backgroundColor: "#E0C8D1",
      },
      {
        label: "D",
        data: [{ x: 100, y: 4, r: 30 }],
        backgroundColor: "#B84167",
      },
      {
        label: "E",
        data: [{ x: 140, y: 3, r: 30 }],
        backgroundColor: "#E04F7D",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            return `${label}: (${context.raw.x}, ${context.raw.y}, ${context.raw.r})`;
          },
        },
      },
      datalabels: {
        display: false,
      },

      bubbleLabels: {
        enabled: true,
        color: "black",
        font: {
          size: 16,
          weight: 500,
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#000",
          callback: function (value) {
            return `${value}`;
          },
        },
        grid: {
          display: false,
        },
        border: {
          color: "#4a4a4a",
          width: 2,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          font: {
            family: "Poppins",
            size: 14,
          },
          color: "#000",
          callback: function (value) {
            return `${value}`;
          },
        },
        border: {
          display: false,
        },
      },
    },
  };

  const bubbleLabelsPlugin = {
    id: "bubbleLabels",
    afterDatasetsDraw(chart, args, options) {
      const { ctx } = chart;
      chart.data.datasets.forEach((dataset, datasetIndex) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        if (meta.type === "bubble") {
          meta.data.forEach((element, index) => {
            const { x, y } = element.tooltipPosition();
            ctx.fillStyle = options.color;
            ctx.font = `${options.font.weight} ${options.font.size}px sans-serif`;
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(dataset.label, x, y);
          });
        }
      });
    },
  };

  return (
    <div className="container mx-auto p-6 bg-white rounded-lg shadow border1 font-inter">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold font4">
          Global XYZ Market Size Study & Forecast By Region 2022-2033 ($
          Million)
        </h2>
        <button className="bg-black text-white px-14 py-2 rounded-xl font-semibold text-center hover:bg-[#21242a]">
          Download
        </button>
      </div>

      <div className="relative h-96 mb-2">
        <Bubble
          data={data}
          options={options}
          plugins={[bubbleLabelsPlugin]} // Add this line
        />
      </div>
    </div>
  );
};

export default BubbleChart;
